/**
 * What a person has counted on one line of a returned parcel, before it is sent.
 *
 * The form holds only this. What is "restocked" or "pending" afterwards is the
 * server's word, drawn from the receipt it answers with.
 */
export interface LineDraft {
  good: number;
  damaged: number;
  missing: number;
  damagedReason: string;
  missingReason: string;
  photos: File[];
}

/** Nothing counted yet: a line starts unchecked, never as "good". */
export const EMPTY_DRAFT: LineDraft = {
  good: 0,
  damaged: 0,
  missing: 0,
  damagedReason: "",
  missingReason: "",
  photos: [],
};
